import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Agata Boeckmann || Full-Stack Developer', // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description:
    'Explore my professional portfolio where I showcase my expertise in web development across key areas.', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: '', // Hello, my name is
  name: 'Agata Boeckmann.', // full name
  subtitle: "I'm a Full-Stack Developer.", // I'm the Unknown Developer.
  cta: 'Learn more', // Know more
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.png',
  imgOnMouseOver: 'profileMouseOver.png',
  paragraphOne:
    "I've always had a passion for coding, a dream I thought would never become a reality. But fate had other plans. My journey into the world of coding began during my maternity leave when I discovered CodeCool and secured a spot with them. I embraced the challenge, juggling diapers and code with equal enthusiasm - learning everything there is to know about becoming a full-stack developer.",
  paragraphTwo:
    "While I appreciate beautiful designs, my heart lies in the backend. I'm a natural tinkerer, always drawn to the mechanics behind the scenes, figuring out what makes the world go round. It's where I feel most at home, crafting elegant and efficient solutions.",
  paragraphThree:
    "Coding isn't just a profession; it's a passion, a journey I'm excited to continue exploring and sharing with the world.",
  stack: 'skills/tech-stack',
  hardskills: '/skills/hard-skills',
  softskills: '/skills/soft-skills',
  resume: '', // 'https://www.resumemaker.online/es.php' if no resume, the button will not show up
};

// CONTACT DATA
export const contactData = {
  cta: '', // call to action text for the contact section
  btn: "Let's talk.", // text inside the button
  email: 'a.boeckmann23+contact@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    // {
    //   id: nanoid(),
    //   name: 'twitter',
    //   url: '',
    // },
    // {
    //   id: nanoid(),
    //   name: 'codepen',
    //   url: '',
    // },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/agata-boeckmann/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/Shcoobz',
    },
    {
      id: nanoid(),
      name: 'codewars',
      url: 'https://www.codewars.com/users/Shcoobz',
      isSvg: true,
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
